import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const TagList = ({ selected, onRemove }) => {
  return (
    <View style={styles.tagContainer}>
      {selected.map(item => (
        <View key={item.fullValue} style={styles.tag}>
          <Text numberOfLines={1}>{item.fullLabel || item.label}</Text>
          <TouchableOpacity onPress={() => onRemove(item.fullValue)}>
            <Text style={styles.remove}>×</Text>
          </TouchableOpacity>
        </View>
      ))}
    </View>
  );
};

export default TagList;

const styles = StyleSheet.create({
  tagContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginRight: 3,
    gap: 5,
    flexShrink: 1,
    flexGrow: 1
  },
  tag: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ebedf0',
    borderRadius: 20,
    paddingHorizontal: 10,
    paddingVertical: 4,
    gap: 5,
    maxWidth: 230
  },
  tagText: {
    color: '#1b2438',
    fontSize: 14,
    marginRight: 4
  },
  remove: {
    color: '#737c8e',
    fontSize: 16,
    fontWeight: 'bold'
  }
});
